import classnames from 'classnames';
import React from 'react';
import { forceCheck } from 'react-lazyload';
import OCButton from '../../components/button';
import Icon from '~/components/icon';
import { type IAccordionType } from '../../interfaces/accordion';
import styles from './accordion.module.css';

interface IProps {
  className?: string;
  testId?: string;
  header: JSX.Element | string;
  body: JSX.Element | JSX.Element[];
  expandByDefault?: boolean;
  expandedHighlight?: boolean;
  accordionType?: IAccordionType;
  displayHighlighter?: boolean;
  isActive?: boolean;
  callback?: () => void;
}

const Accordion: React.FC<IProps> = ({
  className = '',
  testId = '',
  header,
  body,
  expandByDefault,
  expandedHighlight,
  accordionType,
  displayHighlighter,
  isActive,
  callback
}) => {
  const [isExpanded, setIsExpanded] = React.useState(expandByDefault);

  React.useEffect(() => {
    forceCheck();
  }, [isExpanded]);

  React.useEffect(() => {
    if (isActive !== undefined) setIsExpanded(isActive);
  }, [isActive]);

  const toggleExpansion = (): void => {
    if (!isExpanded && callback) {
      callback();
    }

    setIsExpanded((bool) => !bool);
  };

  // We can safely short circuit here
  if (!header || !body) {
    return null;
  }

  const isPromoAccordion = accordionType === 'nested-block';
  const isFaqAccordion = accordionType === 'new-evergreen';

  return (
    <div
      data-testid={testId}
      className={classnames(
        styles.accordion,
        className,
        isFaqAccordion ? styles.faqAccordion : '',
        isPromoAccordion ? styles.promoAccordion : ''
      )}>

			<OCButton
        testId="toggle-button"
        onClick={toggleExpansion}
        className={classnames(
          styles.headerWrapper,
          isExpanded && expandedHighlight ? styles.expandedHighlight : ''
        )}>

				<span className={styles.header}>{header}</span>
				<Icon
          icon={isExpanded ? 'Up' : 'Down'}
          className={classnames(
            styles.icon,
            isExpanded ? styles.highlighted : ''
          )} />

			</OCButton>

			<div
        data-testid="accordion-body-wrapper"
        className={classnames(
          styles.bodyWrapper,
          !isExpanded ? styles.hidden : ''
        )}>

				{body}
				{displayHighlighter && <div className={styles.highlighter} />}
			</div>
		</div>);

};

export default Accordion;